import posthog from 'posthog-js';

// Initialize PostHog
posthog.init('phc_sjSScvR2TqW9Kz4Y9U4S0cqxG4QjVFOwAN0ReadAWCF', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only', // Only create profiles for identified users
  autocapture: true, // Automatically capture clicks, form submissions, etc.
  capture_pageview: true, // Automatically capture pageviews
  capture_pageleave: true, // Capture when users leave pages
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('PostHog loaded');
    }
  }
});

export default posthog;
